import {createChannelTrackingMiddleware} from 'src/shared/channelTracking/middleware';
import {channelTrackingActionMap} from 'src/pages/scheduleCallback/constants/channelTrackingActionMap';

export const channelTracking = createChannelTrackingMiddleware({
  actionMap: channelTrackingActionMap,
});
